import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { IBarChartItem } from "src/types/business-intelligence";
import { formatCompactNumber } from "src/utils";

const colors = ["#0075FF", "#16AA75", "#A155B9", "#CC9C33"];

const StayTimeBreakdown = ({
  data,
  unit,
}: {
  data: IBarChartItem[];
  unit: string;
}) => {
  const theme = useTheme();
  const matchesMediumUp = useMediaQuery(theme.breakpoints.up("md"));

  const xAxisLabels: any = [];
  const stayTimeArr: any = [];

  data?.forEach((item) => {
    xAxisLabels.push(item.label);
    stayTimeArr.push(item.count);
  });

  const series = [
    {
      name: "Stay Time Breakdown",
      data: stayTimeArr,
    },
  ];

  const options: ApexCharts.ApexOptions = {
    theme: {
      mode: "dark",
    },
    noData: {
      text: "No data available ",
      style: {
        fontSize: "15px",
      },
    },
    colors: colors,
    chart: {
      redrawOnParentResize: true,
      type: "line",
      zoom: {
        enabled: false,
      },
      foreColor: "#f0f0f0",
      background: "#242424",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 3,
      shape: "circle",
      strokeColors: colors,
    },
    stroke: {
      width: 2.5,
      curve: "straight",
    },
    grid: {
      show: true,
      borderColor: "#000",
    },
    xaxis: {
      categories: xAxisLabels,
      labels: {
        show: data?.length <= 15,
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => formatCompactNumber(value),
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `${value.toLocaleString()} tickets`,
      },
      x: {
        formatter: (value) => `${value.toLocaleString()} ${unit}`,
      },
    },
    legend: {
      show: true,
      fontSize: "13.3px",
      markers: {
        width: 8,
        height: 8,
        strokeWidth: 0,
        radius: 0,
      },
      itemMargin: {
        horizontal: matchesMediumUp ? 15 : 5,
        vertical: 5,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
      },
    },
  };

  return (
    <Box
      borderRadius={"12px"}
      overflow={"hidden"}
      pb={"10px"}
      bgcolor={"#242424"}
    >
      <Box padding={"21px 24px"} bgcolor={"#242424"}>
        <Typography fontSize={"20px"} fontWeight={700}>
          Stay Time Breakdown
        </Typography>
      </Box>
      <Box height={"2px"} bgcolor={"#000000"} />
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
        width={"100%"}
      />
    </Box>
  );
};

export default StayTimeBreakdown;
